export default "/images/vendor/quill/icons/image.svg?bffb79ce0fc8b41e9e6ce90bea00618b";